import React, { Component } from 'react'

export default class Clients extends Component {
    render() {
        return (
            <div>
                 <section id="clients" class="wow fadeInUp">
      <div class="container">

        <header class="section-header">
          <h3>Our Clients</h3>
        </header>

        <div class="owl-carousel clients-carousel">
          <img src="assets/img/clients/client-1.png" alt=""/>
          <img src="assets/img/clients/client-2.png" alt=""/>
          <img src="assets/img/clients/client-3.png" alt=""/>
          <img src="assets/img/clients/client-4.png" alt=""/>
          <img src="assets/img/clients/client-5.png" alt=""/>
          <img src="assets/img/clients/client-6.png" alt=""/>
          <img src="assets/img/clients/client-7.png" alt=""/>
          <img src="assets/img/clients/client-8.png" alt=""/>
        </div>

      </div>
    </section>
            </div>
        )
    }
}
